export enum ErrorTitlesEnum {
  PageNotFound = 'Ð¡ÑÑÐ°Ð½Ð¸ÑÐ° Ð½ÐµÐ´Ð¾ÑÑÑÐ¿Ð½Ð° Ð¸Ð»Ð¸ Ð½Ðµ ÑÐµÐ°Ð»Ð¸Ð·Ð¾Ð²Ð°Ð½Ð°',
  FileMaxSizeError = 'Ð ÑÐ¾Ð¶Ð°Ð»ÐµÐ½Ð¸Ñ, Ð²ÑÐ±ÑÐ°Ð½Ð½ÑÐ¹ ÑÐ°Ð¹Ð» Ð¿ÑÐµÐ²ÑÑÐ°ÐµÑ Ð´Ð¾Ð¿ÑÑÑÐ¸Ð¼ÑÐ¹ (Ð½Ðµ Ð±Ð¾Ð»ÐµÐµ 50 ÐÐ±) Ð¾Ð±ÑÐµÐ¼ Ð²Ð»Ð¾Ð¶ÐµÐ½Ð¸Ð¹. ÐÐ¾Ð¿ÑÐ¾Ð±ÑÐ¹ÑÐµ Ð²ÑÐ±ÑÐ°ÑÑ Ð´ÑÑÐ³Ð¾Ð¹',

  AdFileMaxSizeError = 'Ð£Ð¼ÐµÐ½ÑÑÐ¸ÑÐµ ÑÐ°Ð·Ð¼ÐµÑ Ð¸ Ð¿Ð¾Ð¿ÑÐ¾Ð±ÑÐ¹ÑÐµ ÑÐ½Ð¾Ð²Ð°',
  AdFileMaxSizeErrorDescription = 'ÐÐ¾Ð¿ÑÐ¾Ð±ÑÐ¹ÑÐµ Ð·Ð°Ð¼ÐµÐ½Ð¸ÑÑ ÑÐ°Ð¹Ð» Ð½Ð° Ð´ÑÑÐ³Ð¾Ð¹ Ð¸Ð»Ð¸ Ð¿Ð¾Ð¿ÑÐ¾Ð±ÑÐ¹ÑÐµ ÐµÑÑ ÑÐ°Ð·',

  AdFileMaxCountError = 'ÐÐ¾ÑÑÑÐ¿Ð½Ð° Ð·Ð°Ð³ÑÑÐ·ÐºÐ° Ð½Ðµ Ð±Ð¾Ð»ÐµÐµ 10 ÑÐ°Ð¹Ð»Ð¾Ð²',
  AdFileMaxCountErrorDescription = 'Ð£Ð´Ð°Ð»Ð¸ÑÐµ Ð»Ð¸ÑÐ½Ð¸Ðµ ÑÐ°Ð¹Ð»Ñ',

  AdFileFormatError = 'ÐÐµÐ´Ð¾Ð¿ÑÑÑÐ¸Ð¼ÑÐ¹ ÑÐ¾ÑÐ¼Ð°Ñ ÑÐ°Ð¹Ð»Ð°',
  AdFileFormatErrorDescription = 'ÐÐ°Ð³ÑÑÐ·Ð¸ÑÑ Ð´ÑÑÐ³Ð¾Ð¹ ÑÐ°Ð¹Ð» Ð¿ÑÐ°Ð²Ð¸Ð»ÑÐ½Ð¾Ð³Ð¾ ÑÐ¾ÑÐ¼Ð°ÑÐ° Ð¸Ð»Ð¸ Ð¿Ð¾Ð¿ÑÐ¾Ð±ÑÐ¹ÑÐµ Ð·Ð°Ð¼ÐµÐ½Ð¸ÑÑ ÑÐ¾ÑÐ¼Ð°Ñ Ñ ÑÑÐ¾Ð³Ð¾ Ð²ÑÑÑÐ½ÑÑ',

  FileFormatError = 'Ð ÑÐ¾Ð¶Ð°Ð»ÐµÐ½Ð¸Ñ, Ð²ÑÐ±ÑÐ°Ð½Ð½ÑÐ¹ ÑÐ°Ð¹Ð» ÑÐ¾Ð´ÐµÑÐ¶Ð¸Ñ Ð½ÐµÐ¿ÑÐ°Ð²Ð¸Ð»ÑÐ½ÑÐ¹ ÑÐ¾ÑÐ¼Ð°Ñ. ÐÐ¾Ð¿ÑÐ¾Ð±ÑÐ¹ÑÐµ Ð²ÑÐ±ÑÐ°ÑÑ Ð´ÑÑÐ³Ð¾Ð¹',

  InvalidExpression = 'ÐÐ°ÑÐµ ÑÐ¾Ð¾Ð±ÑÐµÐ½Ð¸Ðµ ÑÐ¾Ð´ÐµÑÐ¶Ð¸Ñ Ð½ÐµÐºÐ¾ÑÑÐµÐºÑÐ½Ð¾Ðµ Ð²ÑÑÐ°Ð¶ÐµÐ½Ð¸Ðµ. ÐÐ¾Ð¶Ð°Ð»ÑÐ¹ÑÑÐ°, Ð¿ÐµÑÐµÑÐ¾ÑÐ¼ÑÐ»Ð¸ÑÑÐ¹ÑÐµ ÑÐ¾Ð¾Ð±ÑÐµÐ½Ð¸Ðµ.',
}
